import Modal from "components/Modal";
import { FormProvider } from "react-hook-form";
import { AddSeparatorLogicRetVal } from "../../../hooks/useCreateOrUpdateSeparatorLogic.hook";
import { SeparatorMetadataForm } from "../separator/SeparatorMetadataForm";

type Props = {
  logic: AddSeparatorLogicRetVal;
};

export const AddSeparatorModal = ({ logic }: Props) => {
  return (
    <Modal
      isOpen={logic.isModalOpen}
      title={"Nytt objekt"}
      actionText="Spara"
      onClose={logic.onNewSeparatorModalClose}
      actionHandler={logic.onSubmit}
      isLoading={logic.isPending}
      afterClose={logic.afterClose}
    >
      <FormProvider {...logic.form}>
        <SeparatorMetadataForm />
      </FormProvider>
    </Modal>
  );
};